<template>
  <b-modal
    :id="id"
    v-model="modalShow"
    centered
    hide-header
    hide-footer
    :size="this.isBooking ? 'lg' : 'md'"
    z-index="100001"
  >
    <div :class="this.isBooking ? 'row' : ''">
      <div class="signin" :class="this.isBooking ? 'col-6' : ''">
        <h2 class="heading">{{ msg }}</h2>
        <div class="actions">
          <button @click="handleSignInWithGoogle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="30"
              height="30"
            >
              <path
                fill="#FFC107"
                d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
              />
              <path
                fill="#FF3D00"
                d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
              />
              <path
                fill="#4CAF50"
                d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
              />
              <path
                fill="#1976D2"
                d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
              />
            </svg>

            <span>{{ msg }} with Google</span>
          </button>
          <button @click="handleSignInWithFacebook">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              width="30"
              height="30"
            >
              <path
                fill="#3F51B5"
                d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
              />
              <path
                fill="#FFF"
                d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"
              />
            </svg>

            <span> {{ msg }} with Facebook</span>
          </button>
          <div class="or-dividor"></div>
          <form @submit="submitForm">
            <div class="form-input">
              <input
                type="text"
                placeholder="Full Name"
                v-if="signup == true"
                v-model="fullName"
              />
            </div>
            <div class="form-input">
              <input
                type="email"
                placeholder="Email Address"
                v-model="userEmail"
              />
            </div>
            <div class="form-input">
              <input
                :type="password ? 'password' : 'text'"
                placeholder="Password"
                class="password"
                v-model="userPassword"
              />
              <span class="eye" @click="password = !password">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
                    fill="#A1B1BA"
                  />
                </svg>
              </span>
            </div>
            <div v-if="errors.password != ''" class="form-input">
              <span class="error" v-for="(err, index) in errors" :key="index">
                {{ err }}
              </span>
            </div>

            <button type="submit" v-if="signup == true">Get Started</button>
            <button type="submit" v-else>Log In</button>
          </form>
          <span class="privacy" v-if="signup == true">
            By signing up, you agree to our
            <a href="https://journeybinder.com/policy/terms"
              >Terms of Service</a
            >
            and
            <a href="https://journeybinder.com/policy/privacy">Privacy Policy</a
            >.
          </span>
          <span class="other-opt" v-if="signup == true">
            Already have an account?
            <span class="link" @click="signup = false">Sign In</span>
          </span>
          <span class="other-opt" v-else>
            Don't have an account?
            <span class="link" @click="signup = true">Sign Up</span>
          </span>
        </div>
      </div>
      <div class="signin separate-form col-6" v-if="this.isBooking">
        <h2 class="heading">Submit Form</h2>
        <div class="actions">
          <form @submit="submitSeparateForm">
            <div class="form-input">
              <input
                type="text"
                placeholder="Full Name"
                v-model="BookingForm.displayName"
              />
            </div>
            <div class="form-input">
              <input
                type="email"
                placeholder="Email Address"
                v-model="BookingForm.email"
              />
            </div>
            <div class="form-input">
              <input
                type="text"
                placeholder="Contact Number"
                v-model="BookingForm.phoneNumber"
              />
            </div>
            <div v-if="errorsForm != ''" class="form-input">
              <span class="error">
                {{ errorsForm }}
              </span>
            </div>

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "Form",
  props: {
    id: {
      type: String,
      default: "loginModal"
    },
    modalShow: {
      type: Boolean,
      default: false
    },
    isBooking: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      signup: false,
      password: true,
      fullName: "",
      userEmail: "",
      userPassword: "",
      errors: {
        password: ""
      },
      errorsForm: "",
      BookingForm: {
        email: "",
        phoneNumber: "",
        displayName: ""
      }
    };
  },
  mounted() {},
  computed: {
    msg() {
      if (this.signup) return "Sign Up";
      else {
        return "Sign In";
      }
    }
  },
  methods: {
    validatePassword: function(pass) {
      var re =
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[@$!%*?&])[A-Za-zd@$!%*?&]{8,}$";
      return re.match(pass);
    },
    SignInWithGoogle() {
      this.$store
        .dispatch("user/signInWithGoogleAction")
        .then(result => {
          this.$emit("signingCompleted", true);
          this.$bvModal.hide("loginModal");
          //console.log(result);
          this.updateUserProfile(result);
        })
        .catch(err => {
          //console.log(err);
          alert("Oops. " + err.message);
        });
    },
    SignUpWithGoogle() {
      this.$store
        .dispatch("user/signInWithGoogleAction")
        .then(result => {
          this.$emit("signingCompleted", true);
          this.$bvModal.hide("loginModal");
          //console.log(result);
          this.updateUserProfile(result);
        })
        .catch(err => {
          //console.log(err);
          alert("Oops. " + err.message);
        });
    },
    SignInWithFacebook() {
      this.$store
        .dispatch("user/signInWithFacebookAction")
        .then(result => {
          this.$emit("signingCompleted", true);
          this.$bvModal.hide("loginModal");
          //console.log(result);
          this.updateUserProfile(result);
        })
        .catch(err => {
          //console.log(err);
          alert("Oops. " + err.message);
        });
    },
    SignUpWithFacebook() {
      //console.log("sign-up");
    },
    async updateUserProfile(data) {
      const { displayName, photoURL, phoneNumber } = data;
      this.$store
        .dispatch("user/updateProfile", {
          firstname: displayName.split(" ")[0],
          lastname: displayName
            .split(" ")
            .slice(1)
            .join(" "),
          imgURL: photoURL,
          phoneNumber: phoneNumber
        })
        .then(() => {})
        .catch(err => {
          //console.log("createUserProfile", err);
        });
    },
    handleSignInWithGoogle() {
      if (!this.signup) {
        this.SignInWithGoogle();
      } else {
        this.SignUpWithGoogle();
      }
    },
    handleSignInWithFacebook() {
      if (!this.signup) {
        this.SignInWithFacebook();
      } else {
        this.SignUpWithFacebook();
      }
    },
    submitForm(e) {
      e.preventDefault();
      if (this.signup) {
        if (this.validatePassword(this.userPassword)) {
          this.errors.password =
            "Password should be eight character long contains at least one uppercase, one lowercase, one number and one special character!";
          return;
        }
        this.$nprogress.start();
        this.$store
          .dispatch("user/signUpAction", {
            email: this.userEmail,
            password: this.userPassword
          })
          .then(() => {
            this.$store.dispatch("user/setUserName", {
              fullName: this.fullName
            });
            this.$emit("signingCompleted", true);
            this.$bvModal.hide("loginModal");
            this.$nprogress.done();
            this.$router.push("/");
            this.$store.dispatch("user/showNotification", {
              title: "Signed Up",
              description: "You have successfully signed up to HeartBeatFam",
              variant: "success"
            });
          })
          .catch(error => {
            this.$nprogress.done();
            this.$store.dispatch("user/showNotification", {
              title: error.code,
              description: error.message,
              variant: "danger"
            });
          });
        // this.$emit("formSubmitted", {
        //   fullName: this.fullName,
        //   email: this.userEmail,
        //   password: this.userPassword
        // });
      } else {
        this.$nprogress.start();
        this.$store
          .dispatch("user/signInWithEmailAction", {
            email: this.userEmail,
            password: this.userPassword
          })
          .then(() => {
            this.$nprogress.done();
            this.$emit("signingCompleted", true);
            this.$bvModal.hide("loginModal");
            this.$store.dispatch("user/showNotification", {
              title: "Signed Up",
              description: "You have successfully signed in to HeartBeatFam",
              variant: "success"
            });
          })
          .catch(error => {
            console.log(error);
            this.$nprogress.done();
            this.$store.dispatch("user/showNotification", {
              title: error.code,
              description: error.message,
              variant: "danger"
            });
          });
        // this.$emit("formSubmitted", {
        //   email: this.userEmail,
        //   password: this.userPassword
        // });
      }
    },
    submitSeparateForm(e) {
      e.preventDefault();
      this.$nprogress.start();
      // eslint-disable-next-line no-useless-escape
      let phonenum = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
      let emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (
        this.BookingForm.email == null ||
        this.BookingForm.email == "" ||
        this.BookingForm.phoneNumber == null ||
        this.BookingForm.phoneNumber == "" ||
        this.BookingForm.displayName == null ||
        this.BookingForm.displayName == ""
      ) {
        this.errorsForm = "Please fill all feilds";
        return;
      } else if (!this.BookingForm.phoneNumber.match(phonenum)) {
        this.errorsForm = "Please give valid Phone Number";
        return;
      } else if (!this.BookingForm.email.match(emailFormat)) {
        this.errorsForm = "Please give valid Email";
        return;
      }
      this.$emit("BookingForm", this.BookingForm);
      this.$nprogress.done();
      this.$bvModal.hide("loginModal");
    }
  }
};
</script>

<style lang="scss" scoped>

$bp-sm: 576px;
$bp-md: 768px;
$bp-tab: 862px;
$bp-lg: 992px;
$bp-lap: 1024px;
$bp-xl: 1200px;

.signin {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  a {
    &:hover {
      box-shadow: none;
    }
  }

  .heading {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    text-transform: capitalize;
    margin-top: 10px;
    color: #474d52;
  }
  .or-dividor {
    position: relative;
    width: 100%;
    margin: 25px 0;
    &::before {
      content: "OR";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
      background-color: #fff;
      width: 60px;
      text-align: center;
      text-transform: uppercase;
      font-weight: normal;
      font-size: 16px;
      color: #474d52;
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
      border-top: 1px solid #e5e5e5;
      width: 100%;
    }
  }

  .actions {
    padding-top: 23px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > button:nth-child(-n + 2) {
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07) !important;
    }

    button,
    input,
    textarea {
      padding: 10px 15px;
      width: 85%;
      border-radius: 40px;
      background-color: #fff;
      border: 1px solid #fff;
      height: 60px;
      margin: 10px 0;
      /*text-transform: capitalize;*/
      box-shadow: 0px 0px 9px 0 #eeeded !important;
      &:focus {
        outline: none;
      }
    }
    button {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-weight: bold;
        font-size: 20px;
        line-height: 27px;
        margin-left: 10px;
      }
      &:nth-child(1) {
        span {
          color: #474d52;
        }
      }
      &:nth-child(2) {
        span {
          color: #395185;
        }
      }
    }
    form {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .form-input {
        width: 85%;
        position: relative;
        .error {
          font-weight: bold;
          color: red;
        }
        .eye {
          height: 22px;
          position: absolute;
          right: 5%;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
        }
        input {
          width: 100%;
          font-size: 20px;
          font-weight: normal;
          line-height: 27px;
          color: #000;
          &:focus {
            outline: none;
          }
        }
      }
      textarea {
        width: 100%;
        font-size: 20px;
        font-weight: normal;
        line-height: 27px;
        color: #000;
        &:focus {
          outline: none;
        }
      }

      button {
        background-color: #557efb;
        font-weight: bold;
        font-size: 20px;
        line-height: 27px;
        color: #fff;
      }
      ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #a1b1ba;
        opacity: 1; /* Firefox */
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #a1b1ba;
      }

      ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #a1b1ba;
      }
    }
    .privacy {
      margin: 10px 0;
      width: 85%;
      text-align: left;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #8d99a0;
      a {
        font-weight: bold;
        text-decoration-line: underline;
        color: #8d99a0;
      }
    }
    .other-opt {
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #474d52;
      margin: 10px 0;
      font-weight: normal;
      .link {
        cursor: pointer;
        text-decoration: none;
        color: #557efb;
        margin-left: 7px;
        font-weight: bold;
      }
    }
  }
}

.signin.separate-form {
  &::before {
    content: "OR";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: #fff;
    width: 60px;
    text-align: center;
    text-transform: uppercase;
    font-weight: normal;
    font-size: 16px;
    color: #474d52;
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -50%;
    -webkit-transform: rotateZ(90deg);
    transform: rotateZ(90deg);
    z-index: 0;
    border-top: 1px solid #e5e5e5;
    width: 100%;
  }
}

@media (max-width: $bp-lap) {
  .signin {
    .actions {
      button,
      input {
        width: 100%;
      }
      form {
        .form-input {
          width: 100%;
        }
      }
      .privacy {
        width: 100%;
      }
    }
  }
}

@media (max-width: $bp-lap) {
  .signin {
    .actions {
      & > button span {
        font-size: 18px;
      }
    }
  }
}

@media (max-width: $bp-tab) {
  .signin {
    height: auto !important;
  }
}

</style>

<style>
#loginModal___BV_modal_content_ {
  margin-top: 0px;
}
#loginModal___BV_modal_outer_ {
  z-index: 9999 !important;
}
</style>
